var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.463,
    height: 18.601,
    viewBox: "0 0 22.463 18.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    width: 22.463,
    height: 18.601,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Not_show",
    "data-name": "Not show",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M22.843,8.84C22.678,8.512,18.748.812,11.7.812h-.012a9.457,9.457,0,0,0-2.162.249A.805.805,0,1,0,9.89,2.629,7.007,7.007,0,0,1,11.7,2.422c5.25,0,8.671,5.324,9.507,6.777a16.94,16.94,0,0,1-1.745,2.506.805.805,0,1,0,1.232,1.037,18.331,18.331,0,0,0,2.142-3.163.8.8,0,0,0,.01-.739",
    transform: "translate(-0.465 -0.042)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M3.539.236A.806.806,0,0,0,2.4,1.376L4.466,3.439A18.143,18.143,0,0,0,.1,8.776a.806.806,0,0,0-.011.741c.165.328,4.1,8.028,11.16,8.028a10.265,10.265,0,0,0,5.589-1.754l2.579,2.574a.806.806,0,0,0,1.138-1.14Zm5.81,8.079,2.73,2.727a2.023,2.023,0,0,1-.846.223,1.977,1.977,0,0,1-1.462-.546,2.008,2.008,0,0,1-.422-2.4m1.882,7.619c-5.249,0-8.67-5.322-9.505-6.775a16.522,16.522,0,0,1,3.88-4.582L8.18,7.147a3.637,3.637,0,0,0,2.978,5.729c.044,0,.088,0,.132,0a3.615,3.615,0,0,0,1.964-.661l2.416,2.412a8.653,8.653,0,0,1-4.438,1.308",
    transform: "translate(0 0)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotshow);
export default __webpack_public_path__ + "static/media/Not show.bb5bcf3c2b415d3c4b5efc05783a82f6.svg";
export { ForwardRef as ReactComponent };